import { autoRegisterFeature } from '@store/features/factory';

import { patientCoveragesFeature } from './store/feature';

// Auto-register the feature
autoRegisterFeature(patientCoveragesFeature);

// Export everything from store
export * from './store';

// Export types
export * from './types';

// Export shared coverage UI and workflow helpers
export {
  SelfPayCoverageCard,
  SelfPayCoverageToggle,
  useSelfPayCoverageDesignation,
} from './components/SelfPayCoverageDesignation';

// Export eligibility status config utilities
export type { StatusConfig } from './eligibilityStatusConfig';
export { STATUS_CONFIG } from './eligibilityStatusConfig';
